import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { FILTER_BY_OPTIONS } from "../constants";

const FilterBy = () => {
  const dispatch = useDispatch();
  const selectedFilterBy = useSelector((state) => state.activeClients.selectedFilters.filter_by);

  return (
    <div className="select-box-no-width">
      <p>Filter By</p>
      <MultiSelectDropdown
        options={FILTER_BY_OPTIONS}
        includeFilter={false}
        numberDisplayed={0}
        selectedFilters={selectedFilterBy}
        onSelectChange={(data) => dispatch(actionCreators.updateFilterBy(data))}
      />
    </div>
  );
};

export default FilterBy;
